import api from './api';

export const persistSession = (data) => {
  if (data?.success && data?.token && data?.user) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
  }
};

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    persistSession(response.data);
    return response.data;
  },

  async loginWithGoogle(idToken) {
    const response = await api.post('/auth/google', { idToken });
    persistSession(response.data);
    return response.data;
  },

  async logout() {
    await api.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  async getMe() {
    const response = await api.get('/auth/me');
    return response.data;
  },

  async changePassword(currentPassword, newPassword, confirmPassword) {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
      confirmPassword
    });
    return response.data;
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  },

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
};
